import React, { useEffect, useState } from 'react'
import { Table, Image, Button } from 'react-bootstrap'
import { selectCart, incrementQuantity, decrementQuantity, removeFromCart, clearCart } from '../../../slice/itemSlice'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'

const Items = () => {
  
  const dispatch = useDispatch();
  
  const cart = useSelector(selectCart)
  const [total, setTotal] = useState(0);

  useEffect(() => {
    let result = 0;
    cart.map(i => result += (i.price*i.quantity))
    setTotal(result)
  }, [cart])

  return (<>
    { cart.length > 0 ?<Table responsive className='mt-5'>
      <thead>
        <tr>
          <th>Product</th>
          <th>Price</th>
          <th>Quantity</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {cart.map(x => <tr key={x.id}>
          <td >
            <div className='d-flex p-2 p-md-4'>
              <Image className='d-md-block d-none' style={{maxHeight: "130px"}} src={x.image}/>
              <p className='display-36p-0 p-sm-2'>
                {x.name}
              </p>
            </div>
          </td>
          <td  className="fs-2 text-md-align-start"><p className='text-black-50'>{x.price} <span className='text-dark'>$</span></p></td>
          <td >
            <div className="d-flex flex-column">
              <p className='display-5 text-center' style={{minWidth: "60px"}}>{x.quantity}</p>
              <div className='d-flex flex-column flex-sm-row w-100 align-items-center justify-content-between '>
                <Button style={{minWidth:"40px"}} variant="dark" className='mt-1 w-100 w-sm-50 m-md-1' onClick={() => dispatch(incrementQuantity(x.id))}>
                  <FontAwesomeIcon icon={faAngleUp} />
                </Button>
                <Button style={{minWidth:"40px"}} variant='dark' className='mt-1 w-sm-50 w-100 m-md-1' onClick={() => dispatch(decrementQuantity(x.id))}>
                  <FontAwesomeIcon className='' icon={faAngleDown} />
                </Button>
              </div>
              <Button style={{minWidth:"40px"}} variant='danger' className='mt-1 w-100' onClick={() => dispatch(removeFromCart(x.id))}>Remove</Button>
            </div>
          </td>
        </tr>
        
        )}

      </tbody>
    </Table>
    : 
    <div className='w-100 d-flex flex-column flex-sm-row justify-content-between my-4 border-bottom border-dark p-4'>
      <p className='display-6'>Your cart appears to be empty, would you like to explore our website ?</p>
      <Link to="/" className='btn btn-outline-dark fs-2 p-4'>Home Page</Link>
    </div>
    
    }
    <div className='d-flex justify-content-end w-100 display-3 p-2 p-sm-4'>
      {total !== 0 && <Button disabled={total === 0} className='fs-4 my-3 px-3' variant="danger" onClick={() => dispatch(clearCart())}>Clear Cart</Button>}
      {/* <p className='text-black-50'>
        {total} <span className='text-info'>$</span>
      </p> */}
    </div>
  </>)
}

export default Items